import {
  BasePaymentClient,
  PayWithSavedMethodInput,
  SavePaymentCardArgs,
  SavePaymentCardResponse,
  SbpPaymentArgs,
  TinkoffGetQr,
  TinkoffPayment,
  TOrder,
} from "@core/types";
import { CreateYooKassaPaymentInput } from "@core/types";
import { Payments } from "@core/types";

class PaymentClient extends BasePaymentClient {
  async getYooKassaPayment(paymentId: string) {
    throw new Error("getYooKassaPayment not implemented");
  }

  async createYooKassaPayment(input: CreateYooKassaPaymentInput): Promise<any> {
    throw new Error("createYooKassaPayment not implemented");
  }

  async payWithSavedMethod(payWithSavedMethodInput: PayWithSavedMethodInput): Promise<any> {
    throw new Error("payWithSavedMethod not implemented");
  }

  async createPaymentTinkoffQr(orderId: TOrder["id"]): Promise<TinkoffGetQr | null> {
    throw new Error("getPaymentTinkoffQr not implemented");
  }

  async getTinkoffPayment(paymentId: TOrder["id"]): Promise<TinkoffPayment> {
    throw new Error("getTinkoffPaymentStatus not implemented");
  }

  async savePaymentCard(args: SavePaymentCardArgs): Promise<SavePaymentCardResponse> {
    throw new Error("savePaymentCard not implemented");
  }

  async createSBPPayment(args: SbpPaymentArgs): Promise<Payments | null> {
    throw new Error("createSBPPayment not implemented");
  }
}

export default PaymentClient;
